// Persian wording of audit_log action codes for the activity report ("<actor> <phrase> <target>", reference
// AUDIT rows such as "پروژه را ساخت", "کاربر را مسدود کرد"). Unknown codes fall back to their prefix wording.
import type { AuditType } from './ports';

const PHRASE: Record<string, string> = {
  'admin.user_status': 'وضعیت حساب را تغییر داد برای',
  'admin.user_signout': 'کاربر را از همه دستگاه‌ها خارج کرد:',
  'admin.staff_role': 'نقش را تغییر داد برای',
  'admin.staff_removed': 'نقش ادمین را برداشت از',
  'admin.user_invited': 'کاربر را دعوت کرد',
  'admin.user_invitation_created': 'کاربر را دعوت کرد',
  'admin.user_invitation_revoked': 'دعوت کاربر را لغو کرد',
  'admin.user_invitation_accepted': 'دعوت ادمین را پذیرفت',
  'admin.invitation_revoked': 'دعوت به پروژه را لغو کرد',
  'admin.link_revoked': 'لینک فقط‌خواندنی را غیرفعال کرد',
  'admin.link_restored': 'لینک فقط‌خواندنی را دوباره فعال کرد',
  'admin.release_visibility': 'نمایش نسخه را تغییر داد',
  'admin.release_hidden': 'نسخه را پنهان کرد',
  'admin.release_published': 'نسخه را منتشر کرد',
  'admin.mail_test': 'ایمیل آزمایشی فرستاد به',
  'admin.export_users': 'خروجی کاربران گرفت',
  'admin.export_audit': 'خروجی گزارش فعالیت گرفت',
  'brand.settings_updated': 'تنظیمات را تغییر داد',
  'auth.sessions_revoked': 'از دستگاه‌های دیگر خارج شد',
  'auth.registered_external': 'با حساب گوگل ثبت‌نام کرد',
  'auth.identity_linked': 'حساب گوگل را متصل کرد',
  'project.created': 'پروژه را ساخت',
  'project.deleted': 'پروژه را حذف کرد',
  'project.restored': 'پروژه را بازیابی کرد',
  'project.purged': 'پروژه را برای همیشه حذف کرد',
  'projects.purge_trash': 'سطل زباله را پاک کرد',
  'project.share_link_created': 'لینک فقط‌خواندنی ساخت برای',
  'project.share_link_revoked': 'لینک فقط‌خواندنی را غیرفعال کرد برای',
  'invitation.created': 'به پروژه دعوت کرد',
  'invitation.accepted': 'دعوت را پذیرفت',
  'project.member_added': 'عضو اضافه کرد به',
  'project.member_removed': 'عضو را حذف کرد از',
  'domain.added': 'دامنه اضافه کرد',
  'domain.verified': 'دامنه را تأیید کرد',
  'domain.activated': 'دامنه را فعال کرد',
  'domain.disabled': 'دامنه را غیرفعال کرد',
  'domain.removed': 'دامنه را حذف کرد',
  'files.cleanup': 'فایل‌های بی‌استفاده را پاک کرد',
};

/** Fallback classification by action prefix (the server sends `type`; this covers older responses). */
export function auditType(action: string): AuditType {
  if (/^auth\./.test(action)) return 'auth';
  if (/share_link|admin\.link_/.test(action)) return 'share';
  if (/^(project|projects|invitation|files?)\./.test(action) || action === 'admin.invitation_revoked') return 'project';
  if (/^admin\.(user|staff)/.test(action)) return 'user';
  return 'setting';
}

export function auditPhrase(action: string): string {
  if (PHRASE[action]) return PHRASE[action]!;
  const t = auditType(action);
  return t === 'auth' ? 'وارد شد' : t === 'share' ? 'اشتراک را تغییر داد' : t === 'project' ? 'پروژه را تغییر داد' : t === 'user' ? 'کاربر را تغییر داد' : 'تنظیمات را تغییر داد';
}
